var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProfile32 = function SvgProfile32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.077 11.692a4.923 4.923 0 1 0 9.846 0 4.923 4.923 0 0 0-9.846 0m8.26 7.385c2.576 0 4.663 2.755 4.663 6.154H8c0-3.4 2.087-6.154 4.663-6.154h6.674",
    clipRule: "evenodd"
  })));
};
export default SvgProfile32;